<div class="m-1">
    <div *ngIf="user" (click)="profile()" class="d-flex list-item-action align-items-center pointer justify-content-between px-3 py-2">
        <div class="d-flex align-items-center">
            <div class="list-item-icon-profile">
                <base64-image [fileId]="user.profile_image_file_id"></base64-image>
            </div>
            <div class="mx-3 my-2">
                <div class="">
                    {{ user.display_name }}
                </div>
                <div class="small text-muted">
                    {{ user.tag_line }}
                </div>
            </div>
        </div>
        <div class="mr-3">
            <fa-icon [icon]="iconsService.faIconsSolid.faChevronRight"></fa-icon>
        </div>
    </div>
    <div (click)="location.href='mailto:support@binst.net'"
            class="d-flex list-item-action pointer justify-content-between align-items-center px-3 py-2">
        <div class="d-flex align-items-center">
            <div class="list-item-icon ">
                <fa-icon [icon]="iconsService.faIconsSolid.faExclamationCircle"></fa-icon>
            </div>
            <div class="mx-3 my-2">
                Report a problem
            </div>
        </div>
        <div class="mr-3">
            <fa-icon [icon]="iconsService.faIconsSolid.faChevronRight"></fa-icon>
        </div>
    </div>
    <div (click)="location.href='mailto:support@binst.net'"
         class="d-flex list-item-action pointer justify-content-between align-items-center px-3 py-2">
        <div class="d-flex align-items-center">
            <div class="list-item-icon ">
                <fa-icon [icon]="iconsService.faIconsSolid.faJetFighter"></fa-icon>
            </div>
            <div class="mx-3 my-2">
                Send me feedback
            </div>
        </div>
        <div class="mr-3">
            <fa-icon [icon]="iconsService.faIconsSolid.faChevronRight"></fa-icon>
        </div>
    </div>
    <div (click)="logout()"
            class="d-flex list-item-action pointer justify-content-between align-items-center px-3 py-2">
        <div class="d-flex align-items-center">
            <div class="list-item-icon ">
                <fa-icon [icon]="iconsService.faIconsSolid.faUser"></fa-icon>
            </div>
            <div class="mx-3 my-2">
                Log out
            </div>
        </div>
        <div class="mr-3">
            <fa-icon [icon]="iconsService.faIconsSolid.faChevronRight"></fa-icon>
        </div>
    </div>
    <div class="d-flex mx-3 my-3 text-muted small flex-wrap w-100 justify-content-start">
        <a class="me-2 muted-link" href="/terms-of-service">Terms of service</a>
        <a class="mx-2 muted-link" href="/privacy">Privacy Policy</a>
    </div>
</div>